export const EMAIL = 'kelvin@kelvinmang.com'
export const LINKEDIN = 'https://www.linkedin.com/in/kelvinmang/'
export const ACHIEVERS_URL = 'https://achievershk.net/chi/'
export const HIBRO_URL = 'https://hibro.ai/'
export const SITE_URL = 'https://kelvinmang.com'
